import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login/login'
import Desktop from '@/pages/desktop/desktop'
import Home from '@/pages/home/home'
import Person from '@/pages/person/index'

import RhBrand from '@/pages/rhBrand/index.vue'
import RhDetail from '@/pages/rhBrand/detail.vue'
import AddProduct from '@/pages/rhBrand/addProduct.vue'
import MajorBrand from '@/pages/majorBrand/index.vue'
import MajorDetail from '@/pages/majorBrand/detail.vue'
import AddMajor from '@/pages/majorBrand/addProduct.vue'
import ChildrenAccount from '@/pages/businessInfo/children-account.vue'
import Account from '@/pages/businessInfo/account.vue'
import BrandProduct from '@/pages/productManagement/brand.vue'
import AddBrand from '@/pages/productManagement/brandDetail.vue'
import FactoryProduct from '@/pages/productManagement/factory.vue'
import MajorProduct from '@/pages/productManagement/major.vue'
import AddMajorProduct from '@/pages/productManagement/majorDetail.vue'
import ServiceProduct from '@/pages/productManagement/service.vue'
import AddService from '@/pages/productManagement/serviceDetail.vue'
import AddFactory from '@/pages/productManagement/factoryDetail.vue'
import Category from '@/pages/systemManagement/category.vue'
import Area from '@/pages/systemManagement/area.vue'
import Roles from '@/pages/systemManagement/roles.vue'
import Users from '@/pages/systemManagement/users.vue'
import Menu from '@/pages/systemManagement/menu.vue'

import EditPassword from '@/pages/password/editPassword'
import RolesManage from '@/pages/roles/roles_manage'
import AccountManage from '@/pages/account/account_manage'
import AuthorityManage from '@/pages/authority/authority_manage'

import TradeDocking from '@/pages/tradeDocking/index.vue'
import TradeDetail from '@/pages/tradeDocking/detail.vue'

import VisitInfo from '@/pages/visitInfo/index.vue'
import VisitInfoDetail from '@/pages/visitInfo/detail.vue'

import ExhibitionActivity from '@/pages/exhibitionActivity/index'

import DataHome from '@/pages/dataHome'

import SystemNotice from '@/pages/systemNotice'
import SystemNoticeDetail from '@/pages/systemNotice/detail'

import ToDo from '@/pages/toDo'

import FissionInfo from '@/pages/fissionInfo'

import BusinessmanActivity from '@/pages/exhibitionManage/businessmanActivity'
import BusinessmanActivityDetail from '@/pages/exhibitionManage/businessmanActivity/detail.vue'

import SendingSamples from '@/pages/SendingSamples'
import SendingSamplesDetail from '@/pages/SendingSamples/detail'

import MateMeetTopicIndex from '@/pages/mateMeetTopic/index.vue'
import MateMeetTopicDetail from '@/pages/mateMeetTopic/detail.vue'

import MeetSessionIndex from '@/pages/meetSession/index.vue'
import MeetSessionDetail from '@/pages/meetSession/detail.vue'

import ExhibitionIndex from '@/pages/codeData/exhibitionIndex'
import FactoryCompanyIndex from '@/pages/codeData/factoryCompanyIndex'
import ServiceCompanyIndex from '@/pages/codeData/serviceCompanyIndex'
import RhBrandIndex from '@/pages/codeData/rhBrandIndex'
import MajorBrandIndex from '@/pages/codeData/majorBrandIndex'
import RhProductIndex from '@/pages/codeData/rhProductIndex'
import MajorProductIndex from '@/pages/codeData/majorProductIndex'
import FactoryProductIndex from '@/pages/codeData/factoryProductIndex'
import ServiceProductIndex from '@/pages/codeData/ServiceProductIndex'
import SpecialActivityIndex from '@/pages/codeData/specialActivityIndex'
import ExhibitionActivityIndex from '@/pages/codeData/exhibitionActivityIndex'

import CyberStar from '@/pages/cyberStar/index'
import CyberStarDetail from '@/pages/cyberStar/detail'

import ExhibitorContactPerson from '@/pages/exhibitorContactPerson/index'

import ExchangeCards from '@/pages/exchangeCards/index.vue'
import ExchangeCardsDetail from '@/pages/exchangeCards/detail.vue'

import OfflineReservation from '@/pages/offlineReservation/index.vue'
import OfflineReservationDetail from '@/pages/offlineReservation/detail.vue'

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login // 登录页面
    },
    {
      path: '/desktop',
      name: 'desktop',
      component: Desktop,
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home // 首页
        },
        {
          path: '/person',
          name: 'Person',
          component: Person
        },
        {
          path: '/rhBrand',
          name: 'RhBrand',
          component: RhBrand
        },
        {
          path: '/rhDetail',
          name: 'RhDetail',
          component: RhDetail,
          meta: {
            belong: '/rhBrand'
          }
        },
        {
          path: '/addProduct',
          name: 'AddProduct',
          component: AddProduct,
          meta: {
            belong: '/rhBrand'
          }
        },
        {
          path: '/majorBrand',
          name: 'MajorBrand',
          component: MajorBrand
        },
        {
          path: '/majorDetail',
          name: 'MajorDetail',
          component: MajorDetail,
          meta: {
            belong: '/majorBrand'
          }
        },
        {
          path: '/addMajor',
          name: 'AddMajor',
          component: AddMajor,
          meta: {
            belong: '/majorBrand'
          }
        },
        {
          path: '/childrenAccount',
          name: 'ChildrenAccount',
          component: ChildrenAccount
        },
        {
          path: '/account',
          name: 'Account',
          component: Account,
          meta: {
            belong: '/childrenAccount'
          }
        },
        {
          path: '/brandProduct',
          name: 'BrandProduct',
          component: BrandProduct
        },
        {
          path: '/majorProduct',
          name: 'MajorProduct',
          component: MajorProduct
        },
        {
          path: '/addMajorProduct',
          name: 'AddMajorProduct',
          component: AddMajorProduct,
          meta: {
            belong: '/majorProduct'
          }
        },
        {
          path: '/addBrand',
          name: 'AddBrand',
          component: AddBrand,
          meta: {
            belong: '/brandProduct'
          }
        },
        {
          path: '/factoryProduct',
          name: 'FactoryProduct',
          component: FactoryProduct
        },
        {
          path: '/serviceProduct',
          name: 'ServiceProduct',
          component: ServiceProduct
        },
        {
          path: '/addService',
          name: 'AddService',
          component: AddService,
          meta: {
            belong: '/serviceProduct'
          }
        },
        {
          path: '/addFactory',
          name: 'AddFactory',
          component: AddFactory,
          meta: {
            belong: '/factoryProduct'
          }
        },

        {
          path: '/area',
          name: 'Area',
          component: Area
        },
        {
          path: '/category',
          name: 'Category',
          component: Category
        },
        {
          path: '/roles',
          name: 'Roles',
          component: Roles
        },
        {
          path: '/users',
          name: 'Users',
          component: Users
        },
        {
          path: '/menu',
          name: 'Menu',
          component: Menu
        },
        {
          path: '/password',
          name: 'password',
          component: EditPassword // 修改密码
        },
        {
          path: '/roles_manage',
          name: 'roles_manage',
          component: RolesManage // 角色管理
        },
        {
          path: '/account_manage',
          name: 'account_manage',
          component: AccountManage // 账号管理
        },
        {
          path: '/authority_manage',
          name: 'authority_manage',
          component: AuthorityManage // 权限管理
        },
        {
          path: '/tradeDocking',
          name: 'TradeDocking',
          component: TradeDocking
        },
        {
          path: '/tradeDetail',
          name: 'TradeDetail',
          component: TradeDetail,
          meta: {
            belong: '/tradeDocking'
          }
        },
        {
          path: '/visitInfo',
          name: 'VisitInfo',
          component: VisitInfo
        },
        {
          path: '/visitInfoDetail',
          name: 'VisitInfoDetail',
          component: VisitInfoDetail
        },
        {
          path: '/exhibitionActivity',
          name: 'ExhibitionActivity',
          component: ExhibitionActivity
        },
        {
          path: '/dataHome',
          name: 'DataHome',
          component: DataHome
        },
        {
          path: '/systemNotice',
          name: 'SystemNotice',
          component: SystemNotice
        },
        {
          path: '/systemNoticeDetail',
          name: 'SystemNoticeDetail',
          component: SystemNoticeDetail,
          meta: {
            belong: '/systemNotice'
          }
        },
        {
          path: '/toDo',
          name: 'ToDo',
          component: ToDo
        },
        {
          path: '/fissionInfo',
          name: 'FissionInfo',
          component: FissionInfo
        },
        {
          path: '/businessmanActivity',
          name: 'BusinessmanActivity',
          component: BusinessmanActivity
        },
        {
          path: '/businessmanActivityDetail',
          name: 'BusinessmanActivityDetail',
          component: BusinessmanActivityDetail,
          meta: {
            belong: '/businessmanActivity'
          }
        },
        {
          path: '/sendingSamples',
          name: 'SendingSamples',
          component: SendingSamples
        },
        {
          path: '/sendingSamplesDetail',
          name: 'SendingSamplesDetail',
          component: SendingSamplesDetail,
          meta: {
            belong: '/sendingSamples'
          }
        },
        {
          path: '/exhibitionIndex',
          name: 'ExhibitionIndex',
          component: ExhibitionIndex
        },
        {
          path: '/factoryCompanyIndex',
          name: 'FactoryCompanyIndex',
          component: FactoryCompanyIndex
        },
        {
          path: '/serviceCompanyIndex',
          name: 'ServiceCompanyIndex',
          component: ServiceCompanyIndex
        },
        {
          path: '/rhBrandIndex',
          name: 'RhBrandIndex',
          component: RhBrandIndex
        },
        {
          path: '/majorBrandIndex',
          name: 'MajorBrandIndex',
          component: MajorBrandIndex
        },
        {
          path: '/rhProductIndex',
          name: 'RhProductIndex',
          component: RhProductIndex
        },
        {
          path: '/majorProductIndex',
          name: 'MajorProductIndex',
          component: MajorProductIndex
        },
        {
          path: '/factoryProductIndex',
          name: 'FactoryProductIndex',
          component: FactoryProductIndex
        },
        {
          path: '/serviceProductIndex',
          name: 'ServiceProductIndex',
          component: ServiceProductIndex
        },
        {
          path: '/specialActivityIndex',
          name: 'SpecialActivityIndex',
          component: SpecialActivityIndex
        },
        {
          path: '/exhibitionActivityIndex',
          name: 'ExhibitionActivityIndex',
          component: ExhibitionActivityIndex
        },
        {
          path: '/mateMeetTopic',
          name: 'MateMeetTopic',
          component: MateMeetTopicIndex
        },
        {
          path: '/mateMeetTopicDetail',
          name: 'MateMeetTopicDetail',
          component: MateMeetTopicDetail,
          meta: {
            belong: '/mateMeetTopic'
          }
        },
        {
          path: '/meetSession',
          name: 'MeetSession',
          component: MeetSessionIndex,
          meta: {
            belong: '/mateMeetTopic'
          }
        },
        {
          path: '/meetSessionDetail',
          name: 'MeetSessionDetail',
          component: MeetSessionDetail,
          meta: {
            belong: '/mateMeetTopic'
          }
        },
        {
          path: '/cyberStar',
          name: 'CyberStar',
          component: CyberStar
        },
        {
          path: '/cyberStarDetail',
          name: 'CyberStarDetail',
          component: CyberStarDetail,
          meta: {
            belong: '/cyberStar'
          }
        },
        {
          path: '/offlineReservation',
          name: 'OfflineReservation',
          component: OfflineReservation
        },
        {
          path: '/offlineReservationDetail',
          name: 'OfflineReservationDetail',
          component: OfflineReservationDetail,
          meta: {
            belong: '/offlineReservation'
          }
        },
        {
          path: '/exhibitorContactPerson',
          name: 'ExhibitorContactPerson',
          component: ExhibitorContactPerson
        },
        {
          path: '/exchangeCards',
          name: 'ExchangeCards',
          component: ExchangeCards
        },
        {
          path: '/exchangeCardsDetail',
          name: 'ExchangeCardsDetail',
          component: ExchangeCardsDetail,
          meta: {
            belong: '/exchangeCards'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js